import React from 'react';

const OpPlusLogoSmall = () => {
  return (
    <svg width="48" height="19" viewBox="0 0 48 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="18.4615" rx="4" fill="#C6E2E6" />
      <path
        d="M12.8806 13.3145C15.625 13.3145 17.8497 11.0997 17.8497 8.36758C17.8497 5.63547 15.625 3.42065 12.8806 3.42065C10.1362 3.42065 7.91138 5.63547 7.91138 8.36758C7.91138 11.0997 10.1362 13.3145 12.8806 13.3145Z"
        fill="#F1605D"
      />
      <path
        d="M7.91228 16.2104C10.073 16.2104 11.8246 14.4667 11.8246 12.3157C11.8246 10.1646 10.073 8.4209 7.91228 8.4209C5.75159 8.4209 4 10.1646 4 12.3157C4 14.4667 5.75159 16.2104 7.91228 16.2104Z"
        fill="#FBB25B"
      />
      <path
        d="M9.39542 7.79067C11.0017 7.79067 12.3038 6.49438 12.3038 4.89533C12.3038 3.29628 11.0017 2 9.39542 2C7.78918 2 6.48706 3.29628 6.48706 4.89533C6.48706 6.49438 7.78918 7.79067 9.39542 7.79067Z"
        fill="#74AFDF"
      />
      <path
        d="M17.8507 8.16046C18.8733 8.16046 19.7022 7.33525 19.7022 6.31729C19.7022 5.29934 18.8733 4.47412 17.8507 4.47412C16.8282 4.47412 15.9993 5.29934 15.9993 6.31729C15.9993 7.33525 16.8282 8.16046 17.8507 8.16046Z"
        fill="#393839"
      />
      <path
        d="M11.8761 12.3166C11.867 12.6179 11.8316 12.9178 11.7702 13.213C10.6901 12.9511 9.72883 12.3373 9.03919 11.4692C8.34956 10.6011 7.97108 9.52852 7.96387 8.42179C10.0777 8.36906 11.8761 10.1595 11.8761 12.3166Z"
        fill="#EF4625"
      />
      <path
        d="M12.314 4.89469C12.3074 5.66271 11.9971 6.39722 11.4504 6.93913C10.9037 7.48105 10.1645 7.78675 9.39303 7.79002C8.91149 7.79756 8.4376 7.66961 8.02588 7.42089C8.21073 6.44862 8.68832 5.55534 9.39521 4.85969C10.1021 4.16403 11.0049 3.69892 11.9836 3.52612C12.1986 3.95072 12.3117 4.4192 12.314 4.89469Z"
        fill="#6C4255"
      />
      <path
        d="M17.8631 8.16026C17.3744 8.15375 16.9075 7.95739 16.5621 7.61306C16.2167 7.26873 16.0201 6.80368 16.0142 6.31709C16.0127 6.08326 16.0586 5.85154 16.1492 5.63579C16.2398 5.42005 16.3732 5.22473 16.5414 5.06152C17.3349 5.90718 17.803 7.00459 17.8631 8.16026Z"
        fill="#371716"
      />
      <path
        d="M28.7243 9.27464C28.7243 11.2233 27.564 12.3684 25.9496 12.3684C25.6063 12.3855 25.2636 12.3233 24.9485 12.1865C24.6334 12.0497 24.3544 11.842 24.1335 11.5799V14.204H22.6453V6.33913H24.0402V7.12009C24.2516 6.8113 24.5398 6.56227 24.8766 6.39725C25.2135 6.23223 25.5875 6.15684 25.9623 6.17842C27.564 6.17842 28.7243 7.326 28.7243 9.27464ZM27.2109 9.27464C27.2109 8.20741 26.5903 7.51685 25.6444 7.51685C24.6985 7.51685 24.0679 8.21494 24.0679 9.27464C24.0679 10.3343 24.6884 11.0324 25.6444 11.0324C26.6004 11.0324 27.2058 10.3519 27.2058 9.27464H27.2109Z"
        fill="#333333"
      />
      <path d="M29.7988 4.18457H31.2971V12.2202H29.7988V4.18457Z" fill="#333333" />
      <path
        d="M37.9673 6.33936V12.2079H36.5724V11.339C36.3202 11.9693 35.5937 12.3686 34.8067 12.3686C33.4244 12.3686 32.6072 11.4997 32.6072 10.2366V6.33936H34.1055V9.87001C34.1055 10.5807 34.61 10.9925 35.291 10.9925C35.9721 10.9925 36.4766 10.5807 36.4766 9.87001V6.33936H37.9673Z"
        fill="#333333"
      />
      <path
        d="M38.8567 10.9592L40.1911 10.1908C40.3081 10.4646 40.504 10.6978 40.7541 10.8609C41.0041 11.0241 41.2971 11.1098 41.596 11.1074C42.2418 11.1074 42.4814 10.811 42.4814 10.5223C42.4814 10.2335 42.3225 10.1104 41.7928 9.99493L40.9503 9.8066C39.4898 9.50275 39.0156 8.89506 39.0156 8.04881C39.0156 7.04435 39.8884 6.16797 41.4674 6.16797C42.9178 6.16797 43.6796 6.93637 43.9419 7.50891L42.6403 8.24216C42.523 8.00212 42.3396 7.80027 42.1113 7.6602C41.8831 7.52013 41.6195 7.44762 41.3514 7.45116C40.7763 7.45116 40.5341 7.71483 40.5341 7.99105C40.5341 8.26727 40.7409 8.42548 41.306 8.55354L42.1812 8.7469C43.5862 9.05577 43.9999 9.65342 43.9999 10.4771C43.9999 11.5669 43.1599 12.4031 41.5355 12.4031C40.1457 12.3906 39.2678 11.7854 38.8567 10.9592Z"
        fill="#333333"
      />
    </svg>
  );
};

export default OpPlusLogoSmall;
